import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {LIST_PAGINATION_DEFAULT_PAGE_SIZE, LIST_PAGINATION_MIN_PAGE_SIZE} from "~/utilities/ottokart/listPaginationConstants";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/machines/")({
    loader: async () => {},
    validateSearch: (search: Record<string, unknown>) => ({
        create:
            search.create === true || search.create === "true" || search.create === "1"
                ? true
                : undefined,
        offset: typeof search.offset === "number" ? Math.max(0, search.offset) : 0,
        limit:
            typeof search.limit === "number"
                ? Math.max(LIST_PAGINATION_MIN_PAGE_SIZE, search.limit)
                : LIST_PAGINATION_DEFAULT_PAGE_SIZE,
    }),
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
